export default __webpack_public_path__ + "static/media/27-460x460.bd202a88.jpeg";